<template>
  <div>
    <Modal v-model="visible" title="提现结算单" :mask-closable="false" :footer-hide="true" width="1200px" class="my-modal top">
      <Table :columns="columns" :data="tableDate">
        <template slot-scope="{ row }" slot="action">
          <span class="table-btn" @click="lookDetail(row)">查看明细</span>
          <span class="table-btn" @click="exportDetails(row)">导出明细</span>
        </template>
      </Table>
    </Modal>
  </div>
</template>

<script>
import { getBaseUserSalaryList } from '@/api/httpList';
import filter from '@/api/filter';
import { mapState } from 'vuex';
import { common } from '@/api/mixins';

export default {
  mixins: [common],
  data() {
    return {
      visible: false,
      columns: [
        {
          title: '结算周期',
          key: 'settleDate',
          align: 'center',
          minWidth: 140,
          tooltip: true,
          render(h, params) {
            let settleDate = params.row.settleDate;
            return <span>{filter.filterTime(settleDate, 'YYYY-MM-DD')}</span>;
          }
        },
        {
          title: '结算单名称',
          key: 'settleName',
          align: 'center',
          minWidth: 150,
          tooltip: true
        },
        {
          title: '税前合计（元）',
          key: 'totalIncome',
          align: 'center',
          minWidth: 170,
          tooltip: true
        },
        {
          title: '税后合计（元）',
          key: 'realIncome',
          align: 'center',
          minWidth: 140,
          tooltip: true
        },
        {
          title: '操作',
          slot: 'action',
          width: 180,
          align: 'center'
        }
      ],
      tableDate: [],
      detailColumns: []
    };
  },
  computed: {
    ...mapState(['userInfo'])
  },
  methods: {
    lookDetail(row) {
      this.visible = false;
      this.openPageTabTags('/financialManage/myWithdrawal/detail', {
        reportId: row.reportId,
        userId: row.userId,
        title: `${row.staffNo}/${row.userName}${filter.filterTime(row.settleDate, 'YYYY-MM-DD')}结算单明细`
      });
    },
    // 导出明细
    exportDetails({ reportId, userId }) {
      this.$units.downloadFile(
        '/buz/userSalaryDetails/exportByDetail',
        { reportId, userId },
        'POST'
      );
    },
    async getList(userId, withdrawLogId) {
      try {
        const params = { userId, withdrawLogId };
        const res = await getBaseUserSalaryList(params);
        this.tableDate = Array.isArray(res.data) ? res.data : [];
      } catch (error) {
        this.$notice && this.$notice.error('获取结算单列表失败');
        this.tableDate = [];
      }
    },
    open(userId, withdrawLogId) {
      this.visible = true;
      // 避免无效参数调用
      if (userId && withdrawLogId) {
        this.getList(userId, withdrawLogId);
      } else {
        this.tableDate = [];
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.my-modal {
  /deep/ .ivu-modal-body {
    padding-top: 20px;
  }
}
</style>
